import { createContext, useContext } from 'react';
import { UserInstitution, DataPointsProduct } from '#types/generated/graphql';

export type InstitutionContract = {
  hasManyInstitutions: Boolean;
  institution: Omit<UserInstitution, 'products'> & {
    products: Pick<
      DataPointsProduct,
      'name' | 'locations' | 'institutionGroups' | 'peersInfo'
    >[];
  };
  setActiveInstitution: (id: string) => void;
  clearActiveInstitution: () => void;
  apiHeaders: { [key: string]: string };
};

export const defaultInstitutionContext = {
  hasManyInstitutions: false,
  institution: {
    id: '',
    institutionId: '',
    name: '',
    logo: '',
    resource: '',
    country: '',
    countryCode: '',
    continent: '',
    insightsPreviewUrl: null,
    products: [],
    currencyCode: '',
  },
  setActiveInstitution: () => {},
  clearActiveInstitution: () => {},
  apiHeaders: {},
};

const InstitutionContext = createContext<InstitutionContract>(
  defaultInstitutionContext,
);

export const useInstitution = () =>
  useContext<InstitutionContract>(InstitutionContext);

export default InstitutionContext;
